export enum INTEGRATIONS {
  SWELL = "swell",
  SHOPIFY = "shopify",
  KLAVIYO = "klaviyo",
  STRIPE = "stripe",
  SNOWFLAKE = "snowflake",
  BRAZE = "braze",
  API = "api",
}

export interface Integration {
  id: number;
  connectionStatus: string;
  createdAt: string;
  lastUsedAt: string;
  metadata: {
    shopDomain: string;
    shopName: string;
  };
  provider: string;
  error?: Record<string, any> | null;
}

export enum INTEGRATIONS_STATUS {
  CONNECTED = "CONNECTED",
  ERROR = "ERROR",
  DISCONNECTED = "DISCONNECTED",
}
